import { useState } from "react";
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import { Button, Form, Radio, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Box, Typography } from '@mui/material';
import Tab4 from './Tab4';
import SearchModal from "../../../SearchModal";
import InputForm from "../../../InputT";
import SelectOption from "../../../SelectOption";
import DataSelect from '../../../../Types/DataSelect'
import ParamsPicklist from "../../../../Types/ParamsPicklist";
import SearInputG from "../../../SearchInput"
import { Crypter } from "../../../../Functions/Security/Crypter";
import Data from '../../../../Data/Data.json';
import axios from "axios";
import ReformatDate from '../../../../Functions/Traitement/ReformatDate'
import Demand from '../../../../Models/MVirementPermanent';
import formatDate from "../../../../Functions/Traitement/fomatDate";
import { date, string } from "yup";
import formatDate2 from "../../../../Functions/Traitement/formatDate2";
import formatDate3 from "../../../../Functions/Traitement/formatDate3";
import formatNumber from "../../../../Functions/Traitement/FormatNumber";
import { Bold } from "@tremor/react";





const AddVp = () => {
    const dataOption2: DataSelect[] = [
        { label: "ANNUELLE", value: "A" },
        { label: "SEMESTRIELLE", value: "S" },
        { label: "TRIMESTRIELLE", value: "T" },
        { label: "BIMENSUELLE", value: "B" },
        { label: "JOURNALIERE", value: "J" },
        { label: "BIMESTRIELLE", value: "F" },
        { label: "HEBDOMADAIRE", value: "H" },
        { label: "MENSUELLE", value: "M" }
    ]

    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")
    const [LibellId, SetLibellId] = useState(false)


    //let searchCompte: ParamsPicklist = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: 'NUMCLI', Choix: 22 }
    let searchCompte: ParamsPicklist = { CodeAgence: Perss.codage, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: 'agccpt', colfiltre: "", valfiltre: '', Choix: 22 }
    let searchCompte2: ParamsPicklist = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: 'agccpt', colfiltre: "", valfiltre: '', Choix: 22 }


    let searchVirementPerme: ParamsPicklist = { CodeAgence: Perss.codage, Table: "ORDREPERM", Colonne1: "NUMDOS", Colonne2: "LIBCPTDEB", Colagence: 'codage', colfiltre: "", valfiltre: '', Choix: 22 }



    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Virement permanent
                </span>
            ),
            children: <Tab1 />,
        },
    ];

    // Handle function
    function HandleConsult() {
        setConsulte(true);
        setAjoute(true);
        setModife(false);
        setAnnule(false);
        SetLibellId(true)
    }

    function HandleAjout() {
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSbmit('add')
        SetLibellId(true);
    }

    function HandleModif() {
        setEnrege(false);
        setModife(true);
        setActue(false);
        setAnnule(false)
        setFormactve(false);
        setSbmit('modif')
    }

    function HandleEnreg() {

    }

    function HandleAnnul() {

        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setSupprime(true);
        setActue(true);
        setAnnule(true);
        form.resetFields();
        setFormactve(true);
        setSbmit('')
        SetLibellId(false)
    }


    // function consult 
    function consult() {
        if (form.getFieldValue("NUMDOS") == null) {
            SweetAlert.fire({ title: "Svp renseigner le numero de reference", icon: "warning" });
        } else {

            let data = (form.getFieldValue("NUMDOS"));
            let codeage = Perss.codage;
            if (data.length != 0) {
                setLoading(true)
                form.resetFields()
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadVirementPerme,
                    headers: {
                        'CypherREFMARQ': data,
                        'CypherCodeage': codeage,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };
                //console.log("dehors");

                axios.request(config)
                    .then((response) => {
                        setLoading(false);

                        //console.log("dedans :" + JSON.parse(Crypter.decrypt(response.data)));
                        if (response.data) {
                            //const res = JSON.parse(Crypter.decrypt(response.data));
                            const res = JSON.parse(Crypter.decrypt(response.data));
                            //console.log(JSON.stringify(res))
                            let DemandVP = res.Result.Table[0]
                            //console.log(DemandVP);
                            //console.log("dedans");

                            if (res.StatutCode == 200) {
                                HandleConsult();
                                form.setFieldsValue(DemandVP);
                                //console.log(DemandVP);
                                //alert(DemandCHQ.DATDEM)
                                form.setFieldValue("DATIMP", ReformatDate(DemandVP.DATIMP));
                                form.setFieldValue("DATARRIMP", formatDate3(DemandVP.DATARRIMP));
                                 form.setFieldValue("MOTIF", DemandVP.motif);
                                // form.setFieldValue("lib_CPTCRE", DemandVP.);

                                if (DemandVP.DECOUV == '1') {
                                    form.setFieldValue("TYPE1", "D");
                                    //alert('Vrai Decouv');
                                } else {
                                    //alert('Faux Decouv');
                                }

                                if (DemandVP.isbloqAuto == '1') {
                                    form.setFieldValue("TYPE2", "G");
                                    //alert('Vrai isbloqAuto');
                                } else {
                                    //  alert('Faux isbloqAuto');
                                }

                            }
                            else {
                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        //console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        }
    }


    // function getCompte

    function GetCompte() {
        if (form.getFieldValue("NUMCPT") == null) {
            alert(1);

        } else {
            let data = Crypter.encrypt(form.getFieldValue("NUMCPT"));
            // let IDLIMITE = form.getFieldValue("IDLIMITE")
            if (data.length != 0) {

                setLoading(true)
                //form.setFieldValue("IDLIMITE", IDLIMITE)
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.GetCompte,
                    headers: {
                        'CypherNumCpte': data,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                    //data: data
                };
                axios.request(config)
                    .then((response) => {
                        setLoading(false);
                        if (response.data) {
                            const res = JSON.parse(Crypter.decrypt(response.data));
                            //console.log(JSON.stringify(res))
                            let Compte = res.Result.Table[0]
                            //console.log(JSON.stringify(limite))

                            if (res.StatutCode == 200) {
                                //console.log(Compte)
                                //form.setFieldsValue(limite);
                                // NivCons  MNTlimite  NUMOrdre
                                form.setFieldValue("DISPON", Compte.DISPON)


                            }
                            else {
                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        //console.log(error)
                        SweetAlert.fire({ title: "Error Getdispon", text: error, icon: "error" })
                    });
            }
        }
    }

    //-+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

    const handleConsultCompte2 = async () => {
        setLoading(true);
        let NUMCPT = '';
        NUMCPT = form.getFieldValue('CPTCRE');
        let data = Crypter.encrypt(NUMCPT);
        //form.setFieldsValue({ 'DISPONEM': '' })
        let config1 = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.GetCompte,
            headers: {
                'CypherNumCpte': data,
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
            },
        };
        let requestOne = axios.request(config1);

        await axios
            .all([requestOne])
            .then(
                await axios.spread(async (...responses: any) => {
                    const responseOne = responses[0];
                    if (responseOne.data) {
                        const res = JSON.parse(Crypter.decrypt(responseOne.data));
                        if (res.StatutCode == 200) {
                            let datas = res.Result.Table[0];
                            if (res.Result.Table.length > 0) {

                                // alert(datas.DISPON)
                                // alert(formatNumber(datas.DISPON))
                                form.setFieldValue('MTNCPTCRE', formatNumber(datas.DISPON));
                            } else {
                                SweetAlert.fire({ title: "Warning", text: "Compte not found", icon: "warning" })
                            }
                        }
                        else {
                            setLoading(false);
                            SweetAlert.fire({ title: "error", text: res.Message, icon: "error" })
                        }
                    }
                }
                )).catch((errors) => {
                    SweetAlert.fire({ title: "error", text: errors.message, icon: "error" })
                });

        setLoading(false);
    }


    const handleConsultCompte = async () => {
        setLoading(true);
        let NUMCPT = '';
        NUMCPT = form.getFieldValue('CPTDEB');
        let data = Crypter.encrypt(NUMCPT);
        //form.setFieldsValue({ 'DISPONEM': '' })
        let config1 = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.GetCompte,
            headers: {
                'CypherNumCpte': data,
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
            },
        };
        let requestOne = axios.request(config1);

        await axios
            .all([requestOne])
            .then(
                await axios.spread(async (...responses: any) => {
                    const responseOne = responses[0];
                    if (responseOne.data) {
                        const res = JSON.parse(Crypter.decrypt(responseOne.data));
                        if (res.StatutCode == 200) {
                            let datas = res.Result.Table[0];
                            if (res.Result.Table.length > 0) {

                                // alert(datas.DISPON)
                                // alert(formatNumber(datas.DISPON))
                                form.setFieldValue('MTNCPTDEB', formatNumber(datas.DISPON));
                            } else {
                                SweetAlert.fire({ title: "Warning", text: "Compte not found", icon: "warning" })
                            }
                        }
                        else {
                            setLoading(false);
                            SweetAlert.fire({ title: "error", text: res.Message, icon: "error" })
                        }
                    }
                }
                )).catch((errors) => {
                    SweetAlert.fire({ title: "error", text: errors.message, icon: "error" })
                });

        setLoading(false);
    }



    //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


    // function Onfinish
    const onFinish = (values: any) => {

        Getselectcli()
        //console.log(values)
        var DemandVP: Demand = values

        if (form.getFieldValue("TYPE1") === 'D') {
            DemandVP.DECOUV = 'true';
            //alert('Vrai Decouv');
        } else {
            DemandVP.DECOUV = 'false';
            //alert('Faux Decouv');
        }

        if (form.getFieldValue("TYPE2") === 'G') {
            DemandVP.isbloqAuto = 'true';
            //alert('Vrai B');
        } else {
            DemandVP.isbloqAuto = 'false';
            //alert('Faux B');
        }


        //DemandCHQ.NBCHQS = parseInt(DemandCHQ.NBCHQS);
        // DemandVP.DATIMP = formatDate(form.getFieldValue("DATIMP"));
        // DemandVP.DATARRIMP = formatDate(form.getFieldValue("DATARRIMP"));

        // alert((formatDate(form.getFieldValue("DATIMP"))).split("-"))
        // alert((formatDate(form.getFieldValue("DATARRIMP"))).split("/"))

        // let tab = []
        // tab=(formatDate(form.getFieldValue("DATARRIMP"))).split("/");
        // let tab2=[]
        // tab2=tab[2].split("T")
        // let datearret=tab2[0]+'-'+tab[1]+'-'+tab[0]+'T'+tab2[1]
        // alert((formatDate(form.getFieldValue("DATIMP"))))
        // alert(formatDate2(form.getFieldValue("DATARRIMP")))

        //alert(formatDate2(form.getFieldValue("DATARRIMP")))

        DemandVP.DATIMP = formatDate(form.getFieldValue("DATIMP"));
        DemandVP.DATARRIMP = formatDate2(form.getFieldValue("DATARRIMP"));
        DemandVP.codage = Perss.codage;
        DemandVP.UTISAI = Perss.coduti;
        DemandVP.DATSAI = formatDate(Perss.datjour);
        DemandVP.DATMOD = DemandVP.DATSAI;
        DemandVP.UTIMOD = DemandVP.UTISAI;
        DemandVP.datval = formatDate(Perss.datjour);
        DemandVP.IsFRAIS = 1;


        if (sbmit == "add") {

            SweetAlert.fire({
                title: "Création d'un Virement Permanent",
                text: "Voulez-vous Créer le Virement Permanent de :" + form.getFieldValue("lib_CPTDEB") + " vers " + form.getFieldValue("lib_CPTCRE"),
                showCancelButton: true,
                color: "#116599",
                confirmButtonText: "Yes",
                confirmButtonColor: "#116599",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log(JSON.stringify(DemandVP));
                    let data = Crypter.encrypt(JSON.stringify(DemandVP));
                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.CreateVirementPerme,
                        headers: {
                            'CypherVirement': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res)
                                if (res.StatutCode == 200) {
                                    let code = res.Result
                                    //HandleEnreg();
                                    // form.resetFields()
                                    // localStorage.clear()
                                    setIsSubmit(false)
                                    HandleAnnul()
                                    SweetAlert.fire({ title: '', text: "Ordre permanante enregistré avec succès Reference :" + code, icon: "success" })
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            //console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
        if (sbmit == "modif") {

            SweetAlert.fire({
                title: "M.A.J d'un Virement Permanent",
                text: "Voulez-vous mettre à jour le Virement Permanent de :" + form.getFieldValue("lib_CPTDEB") + " vers " + form.getFieldValue("lib_CPTCRE"),
                showCancelButton: true,
                color: "#116599",
                confirmButtonText: "Yes",
                confirmButtonColor: "#116599",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);

                    let data = Crypter.encrypt(JSON.stringify(DemandVP));
                    let config = {
                        method: 'put',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.UpdateVirementPerme,
                        headers: {
                            'CypherVirement': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        //data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res)
                                if (res.StatutCode == 200) {
                                    let code = res.Result
                                    if (res.Message == "IMPOSSIBLE") {
                                        SweetAlert.fire({ title: "Impossible de Modifier un Vp qui à traverser l'étape de validation", icon: "warning" })
                                        HandleAnnul()
                                    } else {
                                        setIsSubmit(false)
                                        HandleAnnul()
                                        SweetAlert.fire({ title: "Mise à jour Effectuer avec Success", text: "Code : " + res.Message, icon: "success" })
                                    }
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
    }


    // function qui ajoute la date fin
    // function GetselectCli(e:any) {
    //     var datef = (form.getFieldValue("DATIMP"));
    //     let Mois =parseInt(e.target.value.substring(5,7)) +1;

    //     let Annee =(e.target.value.substring(0,4)); 
    //     let Jour =(e.target.value.substring(8,10)); 

    //     alert("Annee"+Annee);
    //     alert("Moi"+Mois);
    //     alert("Jour"+Jour);
    //     //form.setFieldValue("DATARRIMP", (datef) );

    // }



    // function de verification 
    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })

        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };

    function Getselectcli() {

        // alert('fre'+form.getFieldValue("FREQIMP"))
        // alert('NBRIMP'+form.getFieldValue("NBRIMP"))
        // alert('DATIMP' + formatDate(form.getFieldValue("DATIMP")))

        let nbr = 0;
        nbr = form.getFieldValue("NBRIMP")

        if (form.getFieldValue("FREQIMP") == null || form.getFieldValue("NBRIMP") == null || form.getFieldValue("DATIMP") == null) {

            SweetAlert.fire({ title: "Error", text: 'Bien vouloir verifier la frequence imputation, le nombre imputation et la date imputation', icon: "warning" })
        } else {
            setLoading(true)
            let data1 = Crypter.encrypt(form.getFieldValue("FREQIMP"));
            let data2 = Crypter.encrypt("" + nbr);
            let data3 = Crypter.encrypt(formatDate(form.getFieldValue("DATIMP")));

            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.GetDateEndVp,
                headers: {
                    'CypherRef': data1,
                    'CypherNbre': data2,
                    'CypherDat': data3,
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json'
                },
                //data: data
            };
            axios.request(config)
                .then((response) => {
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data));
                        let Newdate = res.Result;

                        if (res.StatutCode == 200) {
                            //alert(ReformatDate(Newdate))
                            form.setFieldValue("DATARRIMP", ReformatDate(Newdate))
                        }
                    }
                    setLoading(false)
                })
                .catch((error) => {
                    setLoading(false);
                    //console.log(error)
                    SweetAlert.fire({ title: "Error GetDatEndVp", text: error, icon: "error" })
                });
        }
    }



    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> Mise en place Vp : {window.location.pathname.toUpperCase()} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }}>
                <Form disabled={FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { consult() }} type="ghost" htmlType="button" block  >
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Ajoutactv} onClick={() => { HandleAjout() }} type="ghost" htmlType="button" block  >
                                    Ajouter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Modifactv} onClick={() => { HandleModif() }} type="ghost" htmlType="button" block  >
                                    Modifier
                                </Button>
                                <Button size='large' className='bt_add' disabled={Enregactv} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                <Button size='large' className='bt_add' disabled={true} onClick={() => { }} type="ghost" htmlType="button" block>
                                    Supprimer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Actuactv} onClick={() => { form.resetFields() }} type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button>
                                <Button size='large' disabled={Annulactv} onClick={() => { HandleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>

                            <div className='tabItem' >

                                <div style={{ display: 'block flow' }}  >
                                    <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >
                                        <Box fontStyle="inherit" className='border-left '>
                                            <legend> Mise en place des Ordres de Virement Permanent</legend>
                                            <fieldset className="bordure1" style={{ marginTop: -10, width: '85%' }}>
                                                <Box style={{ display: 'flex' }}>
                                                    <Box>
                                                        <Box style={{ marginTop: -5, width: '70%' }}>
                                                            <SearInputG width={7} dissabledCode={LibellId} notRequired Titre=" Recherche" label="Numèro dossier" name="NUMDOS" Taille1={'100%'} Taille2={0} Parametre={searchVirementPerme} form={form} />
                                                        </Box>
                                                        <Box style={{ display: 'flex' }}>
                                                            <Box style={{ marginTop: -12, width: '70%' }}>
                                                                <SearchModal width={7} Titre="" label="Compte à débiter" name="CPTDEB" Taille1={'100%'} Parametre={searchCompte} ExecuteafterSelect1={handleConsultCompte} Taille2={'100%'} form={form} />
                                                            </Box>
                                                            <Box style={{ marginTop: -12, width: '23%', marginBottom: -5 }}>
                                                                <InputForm value={1} notRequired disabled={true} width={0} label="Dispon" type="text" name="MTNCPTDEB" />
                                                            </Box>
                                                        </Box>
                                                        <Box style={{ display: 'flex' }}>
                                                            <Box style={{ marginTop: -12, width: '70%' }}>
                                                                <SearchModal width={7} Titre="" label="Compte à Créditer" name="CPTCRE" Taille1={'100%'} Parametre={searchCompte2} ExecuteafterSelect1={handleConsultCompte2} Taille2={'100%'} form={form} />
                                                            </Box>
                                                            <Box style={{ marginTop: -12, width: '23%', marginBottom: -5 }}>
                                                                <InputForm value={1} notRequired disabled={true} width={0} label="Dispon" type="text" name="MTNCPTCRE" />
                                                            </Box>
                                                        </Box>
                                                        <Box style={{ marginTop: -12, width: '70%', marginBottom: -5 }}>
                                                            <InputForm value={1} width={7} label="Montant " type="number" name="MONTAN" />
                                                        </Box>
                                                <Box fontStyle={'inherit'}  style={{ display: 'flex', paddingLeft: 12, marginTop: 5 }}>
                             
                                                <Form.Item name={"TYPE1"} style={{ marginLeft: '1%', display: "flex", marginTop: -15, width: '50%' }}>
                                                    <Radio.Group disabled={false}>
                                                        <Radio value={"D"}> <span style={{ fontWeight: 'bold' }}>{"Découvert"}</span></Radio>
                                                    </Radio.Group>
                                                </Form.Item >
                                                <Form.Item name={"TYPE2"} style={{ marginLeft: '1%', display: "flex", marginTop: -15, width: '50%' }}>
                                                    <Radio.Group disabled={false}>
                                                        <Radio value={"G"}> <span style={{ fontWeight: 'bold' }}>{"Bloquage Automatique ?"}</span></Radio>
                                                    </Radio.Group>
                                                </Form.Item >

                                            </Box>
                                                    </Box>
                                                    <Box style={{ marginLeft: '-5%' }}>
                                                        <Box style={{ width: '100%', marginTop: -5 }}>
                                                            <InputForm value={1} defaultValue={Perss.datjour} width={13} label="Prochaine Imputation" type="date" name="DATIMP" />
                                                        </Box>
                                                        <Box style={{ width: '100%', marginTop: -8 }}>
                                                            <InputForm value={1} width={13} label="Nbre Imputation" type="number" name="NBRIMP" />
                                                        </Box>
                                                        <Box style={{ marginTop: -12 }}>
                                                            <Form.Item style={{ width: '100%', marginBottom: -12, marginTop: 0, paddingLeft: 0 }} >
                                                                < SelectOption Option={dataOption2} width={13} onchange={Getselectcli} label="Fréquence Imputation" Size={'100%'} name="FREQIMP" />
                                                            </Form.Item>
                                                        </Box>
                                                        <Box style={{ width: '100%', marginTop: -8, marginBottom: -5 }}>
                                                            <InputForm value={1} disabled={true} defaultValue={Perss.datjour} width={13} label="Arrêt Imputation" type="text" name="DATARRIMP" />
                                                        </Box>

                                                    
                                                    </Box>
                                                </Box>
                                            </fieldset>
                                            <fieldset className="bordure1" style={{ width: '85%' }}>
                                                <Box style={{ marginTop: -5, width: '85%' }}>
                                                    <InputForm value={1} width={5} label="Libellé écriture Débit" type="texte" name="LIBCPTDEB" />
                                                </Box>
                                                <Box style={{ marginTop: -10, width: '85%' }}>
                                                    <InputForm value={1} width={5} label="Libellé écriture Crédit" type="texte" name="LIBCPTCRE" />
                                                </Box>
                                                <Box style={{ marginTop: -5, width: '85%' }}>
                                                    <InputForm value={1} width={5} label="Motif du Virement" type="texte" name="MOTIF" />
                                                </Box>
                                                
                                            </fieldset>
                                           
                                            <Box style={{ marginLeft: -11, marginTop: -5 }}>
                                                <Tab4 form={form} />
                                            </Box>
                                        </Box>
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div >
    );

}

export default AddVp;